import { BeatLoader } from './BeatLoader';
import { BEAT_PATTERNS } from '../../../src/constants/danceLoaders';

// 1-2-3-(4)-5-6-7-(8) — quick-quick-slow, beats 4 & 8 rest
export function SalsaLoader() {
  return <BeatLoader pattern={BEAT_PATTERNS.salsa} />;
}
